// extracted by mini-css-extract-plugin
module.exports = {"button":"skins-primary-button-31140067"};